import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { editCompetencieXCompetencieType } from "../../redux/descriptorsProfiles/competencies/actions";

const CompetenceRange = (props) => {
  const [value, setValue] = useState(props.item.nivel_desarrollo);
  const [isSelect, setIsSelect] = useState(
    parseInt(props.item.nivel_desarrollo) > 0
  );
  const dispatch = useDispatch();
  const userRoles = useSelector((store) => store.auth.userRoles);
  return (
    <Col className="d-flex flex-wrap justify-content-center align-items-center">
      <label
        for={`exampleInputEmail${props.item.id}`}
        className="mb-0 mr-3 text-muted font-weight-bold"
      >
        {value}
      </label>
      <input
        id={`exampleInputEmail${props.item.id}`}
        className="border-0"
        type="range"
        min="0"
        max="5"
        value={value}
        disabled={
          (value === 0 && props.numCompetencias === props._numCompetencias) ||
          (value === 0 &&
            !props.competenceType.competencia_indispensable &&
            parseInt(props.total) === 0) ||
          (userRoles.length > 0 &&
            !(
              userRoles.includes("jefe") ||
              userRoles.includes("administrador") ||
              userRoles.includes("Responsable_Descriptores_Perfiles")
            ))
        }
        onChange={(changeEvent) => {
          if (props.numCompetencias > props._numCompetencias) {
            if (changeEvent.target.value > value) {
              if (!isSelect) {
                props.setNumCompetencias(parseInt(props._numCompetencias) + 1);
                setIsSelect(true);
                if (!props.competenceType.competencia_indispensable) {
                  props.setTotal(parseInt(props.total) - 1);
                }
              }
            } else {
              if (parseInt(changeEvent.target.value) === 0) {
                props.setNumCompetencias(parseInt(props._numCompetencias) - 1);
                setIsSelect(false);
                if (!props.competenceType.competencia_indispensable) {
                  props.setTotal(parseInt(props.total) + 1);
                }
              }
            }
          } else {
            if (parseInt(changeEvent.target.value) === 0) {
              props.setNumCompetencias(parseInt(props._numCompetencias) - 1);
              setIsSelect(false);
              if (!props.competenceType.competencia_indispensable) {
                props.setTotal(parseInt(props.total) + 1);
              }
            }
          }
          setValue(parseInt(changeEvent.target.value));
          setTimeout(() => {
            dispatch(
              editCompetencieXCompetencieType(parseInt(props.item.id), {
                nivel_desarrollo: parseInt(changeEvent.target.value),
              })
            );
          }, 500);
        }}
      />
    </Col>
  );
};

export default CompetenceRange;
